export const ChangelogFilters = ['action', 'exclusion', 'policy', 'user']
export type ChangelogFilter = (typeof ChangelogFilters)[number]

export const ClaimFilters = [
  'claim_types',
  'concept_id',
  'contract_ids',
  'date_of_service_range',
  'diagnosis_codes',
  'edit_types',
  'exclusion_ids',
  'exclusion_state',
  'insight_mode',
  'member_group_ids',
  'member_ids',
  'modifier_codes',
  'network_ids',
  'patient_sex',
  'place_of_service',
  'policy_ids',
  'procedure_codes',
  'provider_alt_ids',
  'provider_npis',
  'provider_tins',
  'revenue_codes',
  'selected_edit',
  'type_of_bills',
  'view',
]
export type ClaimFilter = (typeof ClaimFilters)[number]

export const ClaimDetailsFilters = ['rid']
export type ClaimDetailsFilter = (typeof ClaimDetailsFilters)[number]

export const InfluencingClaimsFilters = ['lineNumber']
export type InfluencingClaimsFilter = (typeof InfluencingClaimsFilters)[number]

export const ExclusionFilters = [
  'alt_id',
  'category',
  'contract_id',
  'date_type',
  'diagnosis_code',
  'edit_type',
  'exclusion_type',
  'group_id',
  'ltss_indicator',
  'modifier',
  'ndc_code',
  'network_id',
  'place_of_service',
  'policy',
  'procedure_code',
  'provider_npi',
  'provider_tin',
  'specialty',
  'status',
  'view',
]
export type ExclusionFilter = (typeof ExclusionFilters)[number]

export const PolicyFilters = [
  'carc',
  'claim_type',
  'diagnosis_code',
  'edit_type',
  'import-csv',
  'insight_mode',
  'insight_type',
  'modifier',
  'policy_updates',
  'procedure_code',
  'rarc',
  'region',
  'review_group',
  'review_status_workspace',
  'source_type_level_1',
  'specialty',
  'topic',
  'view',
  'override_state',
]
export type PolicyFilter = (typeof PolicyFilters)[number]
